var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCongrats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0,
    d: "M0 0H70V70H0z",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200) translate(3.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0C419",
    d: "M44.99 47.145C42.968 49.17 21.525 58.891 5.37 62.872c-1.472.366-3.03-.067-4.102-1.14-1.074-1.075-1.506-2.633-1.14-4.107C4.106 41.458 13.82 20 15.842 17.974L44.99 47.145z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.409,
    cy: 32.559,
    fill: "#D25627",
    rx: 5.425,
    ry: 20.616,
    transform: "translate(30.409150, 32.559359) rotate(-45.000000) translate(-30.409150, -32.559359)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.239,
    cy: 51.752,
    fill: "#955BA5",
    rx: 2.17,
    ry: 2.171
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#955BA5",
    d: "M25.046 28.273c-.439 0-.835-.265-1.003-.67-.168-.407-.075-.874.236-1.185l6.904-6.908c3.713-3.717 4.186-6.558 1.535-9.213-1.113-1.303-2.813-1.95-4.51-1.713-1.197.254-2.295.849-3.162 1.713-.425.412-1.102.406-1.52-.013-.419-.419-.425-1.096-.014-1.522 1.18-1.182 2.682-1.988 4.319-2.316 2.395-.379 4.818.495 6.42 2.316 3.563 3.566 3.047 7.699-1.534 12.283l-6.902 6.91c-.203.204-.48.318-.769.318z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5364",
    d: "M53.428 39.787c-.439 0-.834-.265-1.002-.67-.168-.406-.075-.873.235-1.183 1.103-.97 1.735-2.369 1.735-3.839 0-1.47-.632-2.868-1.735-3.838-1.117-1.355-2.908-1.953-4.614-1.54-1.77.61-3.351 1.67-4.59 3.075l-6.137 6.142c-.424.424-1.11.424-1.534 0-.424-.424-.424-1.111 0-1.535l6.136-6.142c1.506-1.682 3.428-2.938 5.573-3.64 2.451-.628 5.047.187 6.7 2.105 4.238 4.24 1.995 8.751 0 10.748-.203.204-.48.318-.767.317z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0C419",
    d: "M39.622 19.827c-.439 0-.834-.264-1.002-.669-.168-.404-.076-.87.232-1.182.285-.286 6.902-7.097 1.456-13.91-.266-.3-.345-.722-.205-1.098.14-.376.476-.645.873-.698.398-.053.792.118 1.026.444 6.667 8.339-1.53 16.72-1.615 16.8-.203.202-.479.315-.765.313z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.983,
    cy: 19.51,
    fill: "#FF5364",
    rx: 3.254,
    ry: 3.257
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.711,
    cy: 2.171,
    fill: "#3B97D3",
    rx: 2.17,
    ry: 2.171
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.746,
    cy: 41.255,
    fill: "#955BA5",
    rx: 2.17,
    ry: 2.171
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#955BA5",
    d: "M50.983 6.514c-.6 0-1.085-.486-1.085-1.086V4.343c0-.6.485-1.086 1.085-1.086.599 0 1.084.486 1.084 1.086v1.085c0 .6-.485 1.086-1.084 1.086zM54.237 8.685h-1.085c-.599 0-1.085-.486-1.085-1.085 0-.6.486-1.086 1.085-1.086h1.085c.599 0 1.085.486 1.085 1.086 0 .6-.486 1.085-1.085 1.085zM50.983 11.942c-.6 0-1.085-.486-1.085-1.085V9.77c0-.6.485-1.086 1.085-1.086.599 0 1.084.486 1.084 1.086v1.086c0 .6-.485 1.085-1.084 1.085zM48.813 8.685h-1.085c-.599 0-1.085-.486-1.085-1.085 0-.6.486-1.086 1.085-1.086h1.085c.6 0 1.085.486 1.085 1.086 0 .6-.486 1.085-1.085 1.085z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B97D3",
    d: "M59.66 24.97c-.598 0-1.084-.486-1.084-1.086V22.8c0-.6.486-1.086 1.085-1.086s1.085.486 1.085 1.086v1.085c0 .6-.486 1.086-1.085 1.086zM62.915 27.141H61.83c-.599 0-1.084-.486-1.084-1.085 0-.6.485-1.086 1.084-1.086h1.085c.6 0 1.085.486 1.085 1.086 0 .6-.486 1.085-1.085 1.085zM59.66 30.398c-.598 0-1.084-.486-1.084-1.085v-1.086c0-.6.486-1.086 1.085-1.086s1.085.486 1.085 1.086v1.086c0 .6-.486 1.085-1.085 1.085zM57.491 27.141h-1.085c-.599 0-1.084-.486-1.084-1.085 0-.6.485-1.086 1.084-1.086h1.085c.6 0 1.085.486 1.085 1.086 0 .6-.486 1.085-1.085 1.085z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38 50.918c-2.719 1.274-5.93 2.678-9.373 4.082-.514-.324-1.06-.691-1.627-1.09.25-3.08 1.007-6.091 2.236-8.91 2.722 2.268 5.658 4.25 8.764 5.918z",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200) translate(3.000000, 4.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5364",
    fillRule: "nonzero",
    d: "M38 50.784C35.113 52.1 31.701 53.55 28.045 55c-.547-.335-1.126-.714-1.728-1.126-2.222-1.497-4.345-3.137-6.355-4.907-.992-.893-2.018-1.84-3.055-2.878-1.192-1.19-2.277-2.357-3.255-3.502-2.08-2.39-3.97-4.94-5.652-7.628 1.45-3.658 2.899-7.07 4.225-9.959 1.182 2.296 2.534 4.499 4.047 6.591 1.808 2.528 3.797 4.921 5.953 7.16.312.346.647.68.992 1.026 1.73 1.734 3.558 3.369 5.474 4.896 2.892 2.342 6.01 4.39 9.309 6.111z",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200) translate(3.000000, 4.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#955BA5",
    fillRule: "nonzero",
    d: "M28 45.874c-1.196 2.887-1.932 5.973-2.176 9.126-2.036-1.485-3.982-3.11-5.824-4.867.071-3.492.776-6.935 2.074-10.133.286.343.593.675.91 1.018 1.585 1.72 3.26 3.341 5.016 4.856z",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200) translate(3.000000, 4.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B49ACA",
    fillRule: "nonzero",
    d: "M21 40.005c-1.322 3.154-2.04 6.55-2.112 9.995-.926-.873-1.883-1.8-2.85-2.815-1.113-1.164-2.126-2.306-3.038-3.426.108-3.724.94-7.385 2.445-10.759 1.687 2.474 3.543 4.815 5.555 7.005z",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200) translate(3.000000, 4.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5364",
    fillRule: "nonzero",
    d: "M12 61.04c-2.247.69-4.461 1.305-6.577 1.83-1.487.37-3.06-.066-4.143-1.15C.196 60.636-.24 59.064.13 57.577.654 55.46 1.27 53.247 1.96 51 4.93 54.702 8.298 58.069 12 61.04z",
    transform: "translate(-685.000000, -316.000000) translate(430.000000, 284.000000) translate(255.000000, 32.001200) translate(3.000000, 4.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongrats);
export default __webpack_public_path__ + "static/media/congrats.19976305.svg";
export { ForwardRef as ReactComponent };